import * as React from "react";
import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface BlacklistedVersionsCellProps {
  versions: string[] | null | undefined;
  canEdit: boolean;
  onDelete: (version: string) => void;
}

export const BlacklistedVersionsCell: React.FC<BlacklistedVersionsCellProps> = ({
  versions,
  canEdit,
  onDelete
}) => {
  const versionList = versions ?? [];

  if (versionList.length === 0) {
    return (
      <span className="text-xs text-muted-foreground">
        Blacklist is empty
      </span>
    );
  }

  return (
    <div className="flex flex-row flex-wrap gap-1">
      {versionList.map((version) => (
        <Badge
          key={version}
          variant="danger"
        >
          {version}
          {canEdit && (
            <button
              type="button"
              className="ml-0.5 -mr-1 inline-flex size-3.5 items-center justify-center rounded-full hover:bg-destructive/20"
              onClick={() => onDelete(version)}
            >
              <X className="size-3" />
            </button>
          )}
        </Badge>
      ))}
    </div>
  );
};
